const userPromptMessages = {
  'userPrompt.report.header': '報告書削除',
  'userPrompt.message.delete': '本当に削除しますか？',
  'userPrompt.message.dataDelete': '本当にデータを削除しますか？',
  'userPrompt.message.dataRestore': '本当にデータを復元しますか？',
  'userPrompt.message.dataCompleteDelete.1': '本当にデータを削除しますか？',
  'userPrompt.message.dataCompleteDelete.2':
    '※一度削除されたデータは元に戻せません。',
  'userPrompt.message.otherError': '処理に失敗しました',
  'userPrompt.message.serverError': '一時的にサーバーからの応答がありません。',
  'userPrompt.message.status400': '不正なリクエストです。',
  'userPrompt.message.status401':
    'セッションの有効期限が切れました。ログインしてください',
  'userPrompt.message.status404': 'リソースが見つかりません。',
  'userPrompt.message.status500': 'サーバーリクエストに失敗しました。',
  'userPrompt.message.ownUpdate': 'ログインスタッフ自身の情報は編集できません',
  'userPrompt.message.successImport': 'インポート完了',
  'userPrompt.message.failureImport': 'インポート失敗',
  'userPrompt.message.tags.status409.1': 'タグの編集が競合しました。',
  'userPrompt.message.tags.status409.2':
    'お手数ですが、最初からやり直してください。',
  'userPrompt.message.trash.status409.1':
    'ストレージが一杯のため、復元に失敗しました。',
  'userPrompt.message.trash.status409.2':
    'ストレージを確保した上でもう一度操作してください。',
  'userPrompt.message.noGroupUser.1':
    '表示中の作業者は選択したグループに参加していません。',
  'userPrompt.message.noGroupUser.2': 'ダッシュボードに遷移します。',
  'userPrompt.message.staff.sync.authority':
    '全作業者の権限同期を実行します。よろしいですか？',
  'userPrompt.message.report.delete':
    '報告書を削除しますが、宜しいでしょうか？',
  'userPrompt.message.group.noCorporateAdmin':
    '管理者を1人以上登録する必要があります。',
  'userPrompt.message.group.nameConflict.1':
    '入力されたグループ名は既に使用されています。',
  'userPrompt.message.group.nameConflict.2':
    '異なるグループ名を入力してください。',
  'userPrompt.message.deviceAuth.confirm.error':
    'デバイス認証の確認ができませんでした。',
  'userPrompt.message.deviceAuth.resource.expired':
    '認証コードが有効期間外です。再発行してください。',
  'userPrompt.message.deviceAuth.reissue.success1':
    '認証コードを再発行しました。',
  'userPrompt.message.deviceAuth.reissue.success2':
    '管理者にお問い合わせください。',
  'userPrompt.message.deviceAuth.reissue.error':
    '認証コードを再発行できませんでした。',
  'userPrompt.message.deviceAuth.updateSetting.permissionRequired1':
    '対象グループに参加していないため、アクセス制御の',
  'userPrompt.message.deviceAuth.updateSetting.permissionRequired2':
    '設定を変更できません。',
  'userPrompt.message.deviceAuth.updateSetting.joinGroup':
    'グループ管理画面で、対象グループに参加してください。',
  'userPrompt.message.activityLog.download.error':
    'ダウンロードデータの取得に失敗しました。',
  'userPrompt.message.reportEdit.frameLimit':
    '選択できる写真の上限は100件です。',
  'userPrompt.message.deviceAuth.setting.error':
    'メール送信先を1人以上登録する必要があります。',
  'userPrompt.message.reportDownload.error':
    '報告書のダウンロードに失敗しました。',
  'userPrompt.message.deviceAuth.notSetSubscriptions.1':
    '参加中のグループでアクセス制御が未設定のためご利用できません。',
  'userPrompt.message.deviceAuth.notSetSubscriptions.2':
    '管理者にお問い合わせください。',
  'userPrompt.message.deviceAuth.notSetDefaultGroupSubscriptions':
    'アクセス制御を有効にするためには、デフォルトグループの通知先を設定してください。',
  'userPrompt.message.updateDeviceAuthSettings.error':
    'アクセス制御の設定を変更できませんでした。',
  'userPrompt.message.reportEdit.frameDeleted1':
    '報告書を更新できませんでした。',
  'userPrompt.message.reportEdit.frameDeleted2':
    '他のユーザーによってフレームが削除されました。',
  'userPrompt.message.reportCreationFailed':
    '報告書フレームを作成できませんでした。',
  userPrompt: {
    message: {
      reportStatusChanged: {
        complete1: '他ユーザーにより報告書のステータスを完了に',
        complete2: '変更されたため、報告書プレビュー画面へ遷移しました。',
      },
    },
  },
  'userPrompt.button.noDelete': '削除しない',
  'userPrompt.button.delete': '削除',
  'userPrompt.button.noRestore': '復元しない',
  'userPrompt.button.restore': '復元',
  'userPrompt.button.close': '閉じる',
  'userPrompt.button.ok': 'OK',
  'userPrompt.button.cancel': 'キャンセル',
  'userPrompt.button.retry': '再試行する',
  'userPrompt.button.reconnect': '再呼出',
  'userPrompt.button.logout': 'ログアウト',
};

export default userPromptMessages;
